import MembersContainer from 'modules/members/containers/MembersContainer';

const MembersView = () => <MembersContainer />;

export default MembersView;
